(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mount = (root = document) => {
    root.querySelectorAll('[data-zmw-ambient-video]').forEach((video) => {
      if (video.dataset.zmwMotionBound) return;
      const button = video.closest('.zmw-hero')?.querySelector('[data-zmw-motion-toggle]');
      if (!button) return;
      video.dataset.zmwMotionBound = 'true';
      const sync = () => {
        button.textContent = video.paused ? 'Play motion' : 'Pause motion';
        button.setAttribute('aria-pressed', String(!video.paused));
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(sync);
        else video.pause();
      });
      if (reducedMotion.matches) video.pause();
      reducedMotion.addEventListener('change', (event) => { if (event.matches) video.pause(); });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
